// EmailJS Configuration
// You need to sign up at https://www.emailjs.com/ and get these credentials

export const EMAILJS_CONFIG = {
  // Your EmailJS Service ID (found in EmailJS dashboard)
  SERVICE_ID: 'service_5hh4ttq',
  
  // Your EmailJS Template ID (found in EmailJS dashboard)
  TEMPLATE_ID: 'template_0mdscve', // Replace with your actual template ID
  
  // Your EmailJS Public Key (found in EmailJS dashboard)
  PUBLIC_KEY: 'IK7aF_hUFg27vvpfZ',
  
  // Recipient email address
  TO_EMAIL: 'admin@mobicloud.ai'
};

// EmailJS Template Variables (these should match your EmailJS template)
export const TEMPLATE_VARIABLES = {
  to_email: EMAILJS_CONFIG.TO_EMAIL,
  from_name: '',
  from_email: '',
  subject: '',
  message: '',
  reply_to: ''
}; 